// extracted by mini-css-extract-plugin
module.exports = {"reads":"Reads_reads__2xGeA","readsContainer":"Reads_readsContainer__Y_vFo","error":"Reads_error__3UD9Z","emptyMsg":"Reads_emptyMsg__2idSW"};